/// <reference types="vite-plugin-svgr/client" />
import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import i18n from "../../i18n";

const PartnersScreen: React.FC = () => {
  const { t } = i18n;
  const items = [
    {
      icon: (
        <img
          alt={t("Dream Legacy Foundation")}
          className="mw-100"
          src="/images/partners/DreamLegacyFoundation.svg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Le Groupe BBC")}
          className="mw-100"
          src="/images/partners/Le_Groupe_BBC.jpg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Knights Bridge Development Corp")}
          className="mw-60"
          src="/images/partners/KnightsBridge.svg"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Modulink Design Build")}
          className="mw-100"
          src="/images/partners/ModulinkDesignBuild.png"
        />
      ),
    },
    {
      icon: (
        <img alt={t("MCH")} className="mw-100" src="/images/partners/MCH.png" />
      ),
    },
    {
      icon: (
        <img
          alt={t("Canada NRC")}
          className="mw-100"
          src="/images/partners/NRC.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Investissement Québec")}
          className="mw-100"
          src="/images/partners/Investissement_Quebec.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Cycle Momentum")}
          className="mw-100"
          src="/images/partners/Cycle_Momentum.png"
        />
      ),
    },
    {
      icon: (
        <img
          alt={t("Centre For Housing Innovation by DMZ")}
          className="mw-100"
          src="/images/partners/CHL_DMZ.jpg"
        />
      ),
    },
  ];

  return (
    <Container fluid className="screenContainer mt-5 mb-5">
      <Container className="flexContainer">
        <Row className="w-100">
          <Col xs={12}>
            <h2 className="text-center text-lg-start">{t("Our Partners")}</h2>
          </Col>
        </Row>

        <div className="partnersGrid align-items-center mt-4 gap-5">
          {items.map((item, index) => (
            <div key={index} className="partnerContainer">
              {item.icon}
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
};

export default PartnersScreen;
